import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { getTeamPlayers } from "../../../services/player.services";
import DetailCard from "./components/LicensePlayerCard.jsx";
import mainImg from "../assets/dashboard.png";
import CreatePlayerOverlay from "./components/CreatePlayerModal.jsx";
import CreateFastPlayerOverlay from "./components/FastAddPlayer.jsx";
import { useHistory } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import EditPlayerOverlay from "./components/EditPlayer.jsx";
import "./myTeam.css";
import UserSidebar from "../../../components/userSiderbar/userSidebar.jsx";

const MyTeam = () => {
  const [playerData, setPlayerData] = useState(null);
  const [addPlayerVisible, setAddPlayerVisible] = useState(false);
  const [fastAddVisible, setFastAddVisible] = useState(false);
  const [displayPhone, setdisplayPhone] = useState("");
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedPlayer, setSelectedPlayer] = useState(null);

  const user = useSelector((state) => state.auth.user);
  const operatorTeam = useSelector((state) => state.team.selectedTeam);
  // const allRules = useSelector((state) => state.gameReducer.allRules);

  const history = useHistory();

  const toggleAddPlayer = () => {
    setAddPlayerVisible(!addPlayerVisible);
  };

  const playersArrangedData = playerData?.sort(
    (a, b) => a.homeJersey - b.homeJersey
  );

  useEffect(() => {
    handleGetTeamPlayers();
  }, [operatorTeam]);

  useEffect(() => {
    let phoneLength = operatorTeam?.teamId.coachCell.length;
    let formattedNumber = "";
    if (phoneLength === 0) {
      formattedNumber = "none";
    } else {
      if (phoneLength < 4) {
        formattedNumber = operatorTeam?.teamId.coachCell;
      } else if (phoneLength < 7) {
        formattedNumber = `(${operatorTeam?.teamId.coachCell.slice(
          0,
          3
        )}) ${operatorTeam?.teamId.coachCell.slice(3)}`;
      } else {
        formattedNumber = `(${operatorTeam?.teamId.coachCell.slice(
          0,
          3
        )}) ${operatorTeam?.teamId.coachCell.slice(
          3,
          6
        )}-${operatorTeam?.teamId.coachCell.slice(6, 12)}`;
      }
    }
    setdisplayPhone(formattedNumber);
  }, [operatorTeam]);

  const handleGetTeamPlayers = async () => {
    try {
      setLoading(true);
      const response = await getTeamPlayers(
        operatorTeam?.teamId._id,
        user?.token
      );
      setPlayerData(response.data);
    } catch (error) {
      console.log("Err at handleGetTeamPlayers =>> ", error);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  const goBack = () => {
    history.goBack();
  };

  return (
    <div className="myTeamMain">
      <UserSidebar />
      <div className="detailsScreen">
        {/* <h1 className="headerTxtMyTeam" style={{ color: "white" }}>
          TEAM & ROSTER
        </h1> */}

        {error ? (
          <p className="noInternetTxt">
            Connect to the internet and try again!
          </p>
        ) : (
          <>
            <div className="teamAndRosterContainer">
              <div className="teamDataViewTeam">
                <div
                  onClick={() => history.push("/editteam")}
                  className="rowTeamName"
                >
                  <p className="teamNameTxt" style={{ color: "#d4af37" }}>
                    {operatorTeam?.teamId?.teamName}
                  </p>
                  <button
                    onClick={() => history.push("/editteam")}
                    className="editBtnTeam"
                  >
                    <EditIcon style={{ fontSize: 16 }} />
                  </button>
                </div>

                <div className="line" />
                <div className="infoRow">
                  <p className="nameTxtMyTeam">
                    Nick Name : {operatorTeam?.teamId.teamNickName || "none"}
                  </p>
                  <p className="nameTxtMyTeam">
                    Coach Name : {operatorTeam?.teamId.coachName || "none"}
                  </p>
                  <p className="nameTxtMyTeam">Coach Cell : {displayPhone}</p>
                  <p className="nameTxtMyTeam">
                    Coach Email : {operatorTeam?.teamId.coachEmail || "none"}
                  </p>
                  <p className="nameTxtMyTeam">
                    Rules :{" "}
                    {operatorTeam?.teamId
                      ? operatorTeam?.teamId.gameRules.ruleId
                      : "-"}
                  </p>
                </div>
              </div>
              <div className="rosterView">
                <div className="row2">
                  <p className="rosterHeadingTeam">ROSTER</p>

                  <button onClick={toggleAddPlayer} className="addPlyrBtn">
                    <AddCircleIcon
                      style={{ fontSize: 16, color: "red", marginRight: "2px" }}
                    />
                    <p
                      style={{
                        fontSize: "15px",
                        fontWeight: "700",
                        borderBottom: "2px solid red",
                      }}
                    >
                      Add Player
                    </p>
                  </button>
                  <button onClick={() => setFastAddVisible(true)} className="addPlyrBtn">
                    <AddCircleIcon
                      style={{ fontSize: 16, color: "red", marginRight: "2px" }}
                    />
                    <p
                      style={{
                        fontSize: "15px",
                        fontWeight: "700",
                        borderBottom: "2px solid red",
                      }}
                    >
                      Quick Add
                    </p>
                  </button>
                </div>

                {operatorTeam && addPlayerVisible &&  (
                <CreatePlayerOverlay
                  isVisible={addPlayerVisible}
                  onClose={toggleAddPlayer}
                  tid={operatorTeam?.teamId._id}
                  handleGetPlayers={handleGetTeamPlayers}
                />
              )}

                {operatorTeam && (
                  <CreateFastPlayerOverlay
                    isVisible={fastAddVisible}
                    onBackdropPress={() => setFastAddVisible(false)}
                    tid={operatorTeam?.teamId._id}
                    handleGetPlayers={handleGetTeamPlayers}
                    playerData={playerData}
                  />
                )}

                {loading && <p style={{ color: 'red', fontWeight: '700', display: 'flex', justifyContent: "center", }}>Loading...</p>}
                {/* <div className="TMdataRow">
              <p className="playerNameTxtMyTeam" style={{ color: 'white', fontWeight: '700', display: 'flex', justifyContent: "center", marginTop: '5px' }}>TEAM STAT</p>
            </div> */}

                {/* <div className="rosterGridContainer"> */}
                <div className="rosterTableWrapper">
                  <table className="rosterTable">
                    <thead>
                      <div className="rosterHeader">
                        <th>HOME</th>
                        <th>PLAYER</th>
                        <th>AWAY</th>
                      </div>
                    </thead>

                    <tbody>
                      {playersArrangedData &&
                        playersArrangedData.map((v, i) => (
                          <DetailCard
                            key={i}
                            v={v}
                            onSelectPlayer={setSelectedPlayer} // pass handler
                          />
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            {selectedPlayer && (
              <EditPlayerOverlay
                onBackdropPress={() => setSelectedPlayer(null)}
                isVisible={!!selectedPlayer}
                handleGetPlayers={handleGetTeamPlayers}
                teamId={operatorTeam?.teamId._id}
                data={selectedPlayer}
                history={history}
              />
            )}
            {/* </div> */}
          </>
        )}
      </div>
    </div>
  );
};

export default MyTeam;
